import { ChangeDetectionStrategy, Component, EventEmitter, OnInit, Output } from '@angular/core'
import { FormBuilder, FormGroup } from '@angular/forms'
import { DestroyService } from '@core/services/destroy.service'
import { debounceTime, takeUntil } from 'rxjs/operators'

@Component({
  selector: 'lin-chat-search',
  templateUrl: './chat-search.component.html',
  styleUrls: ['./chat-search.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [DestroyService],
  standalone: false,
})
export class ChatSearchComponent implements OnInit {
  form: FormGroup

  @Output() handleSearch = new EventEmitter<string>()

  get isSearchValue(): boolean {
    return !!this.form.get('search').value
  }

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly destroyService: DestroyService,
  ) {}

  ngOnInit(): void {
    this.initForm()
    this.subscribeSearchChange()
  }

  handleClearSearch(): void {
    this.isSearchValue && this.form.get('search').setValue('')
  }

  private initForm(): void {
    this.form = this.formBuilder.group({
      search: '',
    })
  }

  private subscribeSearchChange(): void {
    this.form.get('search').valueChanges.pipe(debounceTime(300), takeUntil(this.destroyService)).subscribe(this.searchValueChangeNext)
  }

  private searchValueChangeNext = (value: string): void => {
    this.handleSearch.emit(value)
  }
}
